import React from 'react'
import fastFood from '../../assets/fastfood.svg'
import Footer from '../../components/Footer/Footer'
import styles from './MyDeliveries.module.css'
import { Link } from 'react-router-dom'

const MyDeliveries = () => {
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <h1>My Deliveries</h1>
            </header>

            <main>
                <p className={styles.status}>Pending deliveries</p>
                <Link to="/track-delivery">
                    <div className={styles.card}>
                        <div className={styles.top}>
                            <img src={fastFood} alt="fast-food" />
                            <div className={styles.name}>
                                <h3>Courier</h3>
                                <small>20 Jan 2020, 11:40 am</small>
                            </div>
                            <div className={styles.deliveryStatus}>
                                <h4>Picking in 18 Min</h4>
                                <small>$ 8.50</small>
                            </div>
                        </div>
                        <div className={styles.bottom}>
                            <p>Jane Anderson</p>
                            <div className={styles.locationIcons}>
                                <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                                <span>......</span>
                                <i className={styles.icon + " fas fa-location-arrow"}></i>
                            </div>
                            <p>John Anderson</p>
                        </div>
                    </div>
                </Link>
                <div className={styles.card}>
                    <div className={styles.top}>
                        <img src={fastFood} alt="fast-food" />
                        <div className={styles.name}>
                            <h3>Courier</h3>
                            <small>20 Jan 2020, 11:40 am</small>
                        </div>
                        <div className={styles.deliveryStatus}>
                            <h4>Picking in 18 Min</h4>
                            <small>$ 8.50</small>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <p>Jane Anderson</p>
                        <div className={styles.locationIcons}>
                            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                            <span>......</span>
                            <i className={styles.icon + " fas fa-location-arrow"}></i>
                        </div>
                        <p>John Anderson</p>
                    </div>
                </div>
                <div className={styles.card}>
                    <div className={styles.top}>
                        <img src={fastFood} alt="fast-food" />
                        <div className={styles.name}>
                            <h3>Courier</h3>
                            <small>20 Jan 2020, 11:40 am</small>
                        </div>
                        <div className={styles.deliveryStatus}>
                            <h4>Picking in 18 Min</h4>
                            <small>$ 8.50</small>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <p>Jane Anderson</p>
                        <div className={styles.locationIcons}>
                            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                            <span>......</span>
                            <i className={styles.icon + " fas fa-location-arrow"}></i>
                        </div>
                        <p>John Anderson</p>
                    </div>
                </div>
                <p className={styles.status}>Past deliveries</p>
                <div className={styles.card}>
                    <div className={styles.top}>
                        <img src={fastFood} alt="fast-food" />
                        <div className={styles.name}>
                            <h3>Courier</h3>
                            <small>20 Jan 2020, 11:40 am</small>
                        </div>
                        <div className={styles.deliveryStatus}>
                            <h4>Picking in 18 Min</h4>
                            <small>$ 8.50</small>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <p>Jane Anderson</p>
                        <div className={styles.locationIcons}>
                            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                            <span>......</span>
                            <i className={styles.icon + " fas fa-location-arrow"}></i>
                        </div>
                        <p>John Anderson</p>
                    </div>
                </div>
                <div className={styles.card}>
                    <div className={styles.top}>
                        <img src={fastFood} alt="fast-food" />
                        <div className={styles.name}>
                            <h3>Courier</h3>
                            <small>20 Jan 2020, 11:40 am</small>
                        </div>
                        <div className={styles.deliveryStatus}>
                            <h4>Picking in 18 Min</h4>
                            <small>$ 8.50</small>
                        </div>
                    </div>
                    <div className={styles.bottom}>
                        <p>Jane Anderson</p>
                        <div className={styles.locationIcons}>
                            <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                            <span>......</span>
                            <i className={styles.icon + " fas fa-location-arrow"}></i>
                        </div>
                        <p>John Anderson</p>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default MyDeliveries
